export const API_URL = "https://shreeramagroind.com/shreeramagro/admin/dynamicQuery";
export const DOMAIN_URL = "https://shreeramagroind.com/shreeramagro/admin/";
